import React from "react";
import { NavLink } from "react-router-dom";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import Navbar from "./Navbar";

const SideBar = () => {
  return (
    <div>

    
      <aside className="  flex-col md:w-fit hidden md:block min-h-screen h-full  px-4 py-8 overflow-y-auto bg-slate-100">
        {/* <div className="flex flex-col items-center mt-2 -mx-2">
          <img
            className="object-cover w-24 h-24 mx-2 rounded-full shadow-lg"
            src="https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80"
            alt="avatar"
          />
          <h4 className="mx-2 mt-2 text-black font-bold">John Doe</h4>
          <p className="mx-2 mt-2     text-black text-4xl">787,150</p>
          <div className=" border-gray-400 border w-full mt-8" />
        </div> */}

        <div className="flex flex-col justify-between flex-1 mt-14">
          <nav>
            <NavLink to={"/"}>
              <span className="flex items-center px-4 py-2">
                <span className="mx-4 font-medium">Dashboard</span>
              </span>
            </NavLink>
{/* 
            <NavLink to={"/buyselllegacy"}>
              <div className="flex items-center px-4 py-2 mt-5 ">
                <span className="mx-4 font-medium">Buy Dio</span>
              </div>
            </NavLink> */}

            <NavLink to={"/accounts"}>
              <div className="flex items-center px-4 py-2 mt-5 ">
                <span className="mx-4 font-medium">
                  Send
                  {/* <ul>
                                        <li>
                                            <NavLink to={'/verify'}>
                                                <div className="flex items-center px-4 py-2 mt-5 ">

                                                    <span className="mx-4 font-medium">Verified</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <></>
                                    </ul> */}
                </span>
              </div>
            </NavLink>
            <NavLink to={"/recipientaccount"}>
              <div className="flex items-center px-4 py-2 mt-5   ">
                <span className="mx-4 font-medium ">Tx Status </span>
              </div>
            </NavLink>
            <NavLink to={"/receivedTx"}>
              <div className="flex items-center px-4 py-2 mt-5   ">
                <span className="mx-4 font-medium ">Received Tx </span>
              </div>
            </NavLink>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default SideBar;
